/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiTracksQueryResponse, GetApiTracksQueryParams, GetApiTracks400, GetApiTracks401, GetApiTracks403, GetApiTracks500 } from "../../types/GetApiTracks.ts";
import { getApiTracksQueryResponseSchema } from "../../zod/TracksSchemas/getApiTracksSchema.ts";

function getGetApiTracksUrl() {
  const res = { method: 'GET', url: `/api/tracks` as const }  
  return res
}

/**
 * @summary Получение списка треков по фильтрам с пагинацией
 * {@link /api/tracks}
 */
export async function getApiTracks({ params }: { params?: GetApiTracksQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiTracksQueryResponse, ResponseErrorConfig<GetApiTracks400 | GetApiTracks401 | GetApiTracks403 | GetApiTracks500>, unknown>({ method : "GET", url : getGetApiTracksUrl().url.toString(), params, ... requestConfig })  
  return getApiTracksQueryResponseSchema.parse(res.data)
}